// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3uYRG","content":"styles_content__1OQZp","checkbox":"styles_checkbox__3CU4x","checkboxLabel":"styles_checkboxLabel__3fv_5"};